import {
    escapePrintViewText,
    normalizeInlineHtml,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildChoiceQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const possibleAnswersHtml = (content.possible_answers || [])
        .map((answer) => {
            const option = escapePrintViewText(answer.option || '')
            const value = normalizeInlineHtml(replaceMediaLikeTagsWithIds(answer.value || ''))

            if (!option && !value) {
                return ''
            }

            return `<p>${option}. ${value}</p>`
        })
        .filter(Boolean)
        .join('')

    return `${questionHtml}${possibleAnswersHtml}`
}

export {buildChoiceQuestionPrintView}
